/*
Item: Clear Dialog component for exporting tables from Statistics.jsx
Name: ClearDialog
Format: Code/Frontend component
*/
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { MultiLanguage } from '../../utils/MultiLanguage';

export default class ClearTableDialog extends Component {
  constructor(props) {
    super(props);
    this.multiLanguage = new MultiLanguage();
    const { onHideClearTable, clearTable } = this.props;
    this.onHideClearTable = onHideClearTable;
    this.clearTable = clearTable;
  }

  renderFooter() {
    return (
      <div>
        <Button
          label="Ja"
          id="yes"
          icon="pi pi-check"
          onClick={() => { this.clearTable(); }}
        />
        <Button
          label="Nein"
          id="no"
          icon="pi pi-times"
          onClick={() => { this.onHideClearTable(); }}
          className="p-button-danger"
        />
      </div>
    );
  }

  render() {
    const { clearTableVisible } = this.props;
    return (
      <div>
        <Dialog
          header="Auswertung zurücksetzen"
          visible={clearTableVisible}
          style={{ width: '40vw' }}
          footer={this.renderFooter()}
          onHide={this.onHideClearTable}
          modal
        >
          <div className="p-grid p-fluid">
            <div className="p-col-12">
              <p>
                Möchten Sie die Tabelle wirklich zurücksetzen?
                Nicht gespeicherte Änderungen gehen verloren.
              </p>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

ClearTableDialog.propTypes = {
  onHideClearTable: PropTypes.func.isRequired,
  clearTable: PropTypes.func.isRequired,
  clearTableVisible: PropTypes.bool.isRequired,
};